import { useCallback, useState } from 'react';
import apiClient from '@utils/api-client';
import { apiInternalBuildingPath } from '../../routes';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
function usePatchBuilding() {
    const namespace = 'features.buildings.update';
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState();
    const [result, setResult] = useState();
    const save = useCallback((building) => {
        return new Promise((resolve, reject) => {
            const controller = new AbortController();
            setSaving(true);
            const patchData = {
                timeZoneOverride: building.timeZoneOverride
            };
            apiClient
                .patch(apiInternalBuildingPath(building.id), undefined, {
                params: {
                    building: patchData
                },
                signal: controller.signal
            })
                .then((response) => {
                const pathResult = response.data.data;
                setResult(pathResult);
                toast.success(translate('success', { namespace }), {
                    position: 'bottom-right',
                    removeDelay: 3000
                });
            })
                .catch((err) => {
                if (!controller.signal.aborted) {
                    setResult(undefined);
                    setError(err);
                    toast.error(translate('error', { namespace }), {
                        position: 'bottom-right',
                        removeDelay: 3000
                    });
                }
            })
                .finally(() => {
                if (!controller.signal.aborted)
                    setSaving(false);
            });
        });
    }, []);
    return { save, saving, error, result };
}
export default usePatchBuilding;
